import React, { Component } from 'react';
import { Select, Radio, message } from 'antd';
import appConfig from './../config/appConfig';
import 'whatwg-fetch';
const Option = Select.Option;
const RadioButton = Radio.Button;
const token = sessionStorage.getItem("token");

/**
 *
 * 工具函数模块，主要实现与业务无关的通用函数
 * @author kongxc, zhengyy
 */
const util = {

    /**
       * 判断对象是否是空值
       *
       * @param Object
       * @author yangxz
       * @return Boolean类型，是否是空值，包括 '',null,undefind
       */
    isNull: (obj) => {
        if (obj == null || obj == '' || obj == undefined) {
            return true;
        } else {
            return false;
        }
    },
    getTreeIds: (obj, objName, children )=>{
        let _children = children || "children";
        let _objName = objName || "ssId";
        let _ids = '';
        if (obj && obj.constructor == Object) {
            let idChild = obj[_children].map((item) => {
                _ids = _ids + "," + item[_objName] + util.getTreeIds(item);
            });
            return _ids;
        }
    },
    findTreeItem: (objArray,objValue,children,objName)=>{
        if (objArray && objArray.constructor == Array){
            let _children = children ||"children";
            let _objName = objName||"ssId";
            if(objArray.length>0){
                let _rightItem = objArray.find((item)=>{
                    return item[_objName] == objValue;
                });
                if (!util.isNull(_rightItem)){
                    return _rightItem;
                }else{
                    let _rightItem = null;
                    for (var i = 0; i < objArray.length;i++){
                        _rightItem = util.findTreeItem(objArray[i][_children], objValue, _children, _objName);
                        if (!util.isNull(_rightItem)){
                            return _rightItem;
                        }
                    }
                }
            }
        }
    },
    /**
     * 根据传入的数据，组装Option组件列表；modify by guomh 2017-11-10 可传入第一个默认选项
     * @param arr, Array类型
     * @author kongxc
     * @return Array类型，组装后的Option列表
     */
    getSelectItems: (arr, noDefault, defaultValue) => {
        var j = [];
        if (!noDefault) {
            j.push(<Option key="default" value="">{defaultValue || '请选择'}</Option>);
        }
        for (var i = 0; i < arr.length; i++) {
            j.push(<Option key={1} value={arr[i].value}>{arr[i].name}</Option>);
        }

		return j;
	},
	/**
	 * 根据传入的数据，组装Radio组件列表
	 * @param arr, Array类型
	 * @author kongxc
	 * @return Array类型，组装后的Radio列表
	 */
	getRadioItems: (arr) => {
		var j = [];
		arr.forEach(function (element) {
			j.push(<RadioButton key={element.value} value={element.value}>{element.name}</RadioButton>);
		}, this);
		return j;
	},
	/**
	 * requestServerData 请求服务器数据
	 * 举例：
	util.requestServerData(
			'http://localhost:7000/api/user/query',
			'POST'
			{username:lilei}
	).then(
		(data)=>{console.log(data)},      //响应码等于200时的回调方法
		(data)=>{console.log(data)}       //响应码不等于200时的回调方法
	)
	* @author FanXH
	* @param {String} url      请求地址，如果是GET方式，把参数拼在url后面
	* @param {String} method   请求方式：POST | GET | PUT
	* @param {obj} params      POST | PUT 方式的参数对象，如{age:123}，GET方式时传空值
	*/
	requestServerData: (url, method, params) => {
		//modify by  guomh 2017-11-22 begin 由于暂时未接入okapi，直接访问dubbo-folio-wapper 封装一些headers信息，以便后台接口使用
		let _token = sessionStorage.getItem("token") || "";
		let _headers = new Headers({
			"X-Okapi-Tenant": appConfig.XOkapiTenant,
			"Content-type": "application/json",
			"X-Okapi-Token": _token
		});
		//let _headers = new Headers();
		let _promise = new Promise(
			function (resolve, reject) {
				let _myInit = {
					method: method,
					headers: _headers,
		//modify by  guomh 2017-11-22 end
					mode: 'cors'
				};
				if (method.toUpperCase() != 'GET') {
					_myInit.body = JSON.stringify(params);
				}
				fetch(url, _myInit).then(
					(res) => {
						if (res.status == 200) {// 浏览器判断后台返回值
							res.json().then(
								(data) => {
									if (data.code === 200) {
										resolve(data);
									} else {
										reject(data);
									}
								}
							);
						} else {
							message.error("HTTP请求出错，错误代码:" + res.status, 3);
						}
					}).catch((reason) => {
						message.error(`请求失败，地址：${url},方法：${method},原因：${reason}`, 5);
					});
			}
		);
		return _promise;
	},

    requestServerDataNew: (url, method, params) => {
		//modify by  guomh 2017-11-22 begin 由于暂时未接入okapi，直接访问dubbo-folio-wapper 封装一些headers信息，以便后台接口使用
		//let _headers = new Headers();
        let _headers = new Headers({
			"Content-type": "application/json",
            
		});
		//let _headers = new Headers();
		let _promise = new Promise(
			function (resolve, reject) {
				let _myInit = {
					method: method,
					headers: _headers,
		//modify by  guomh 2017-11-22 end
					mode: 'cors'
				};
				if (method.toUpperCase() != 'GET') {
					_myInit.body = JSON.stringify(params);
				}
				fetch(url, _myInit).then(
					(res) => {
						if (res.status == 200) {// 浏览器判断后台返回值
							res.json().then(
								(data) => {
									if (data.success) {
										resolve(data);
									} else {
										reject(data);
									}
								}
							);
						} else {
							message.error("HTTP请求出错，错误代码:" + res.status, 3);
						}
					}).catch((reason) => {
						message.error(`请求失败，地址：${url},方法：${method},原因：${reason}`, 5);
					});
			}
		);
		return _promise;
	},

    requestServerDataNew: (url, method, params) => {
		//modify by  guomh 2017-11-22 begin 由于暂时未接入okapi，直接访问dubbo-folio-wapper 封装一些headers信息，以便后台接口使用
		let _headers = new Headers({
            "Content-type": "application/json",
        });
		let _promise = new Promise(
			function (resolve, reject) {
				let _myInit = {
					method: method,
		//modify by  guomh 2017-11-22 end
                    headers: _headers,
					mode: 'cors'
				};
				if (method.toUpperCase() != 'GET') {
					_myInit.body = JSON.stringify(params);
				}
				fetch(url, _myInit).then(
					(res) => {
						if (res.status == 200) {// 浏览器判断后台返回值
							res.json().then(
								(data) => {
									if (data.success) {
										resolve(data);
									} else {
										reject(data);
									}
								}
							);
						} else {
							message.error("HTTP请求出错，错误代码:" + res.status, 3);
						}
					}).catch((reason) => {
						message.error(`请求失败，地址：${url},方法：${method},原因：${reason}`, 5);
					});
			}
		);
		return _promise;
	},

    /**
    * postData 请求服务器数据
     举例：
     util.requestServerData(
     		'http://localhost:7000/api/user/query',
     		{username:lilei}
     ).then(
 	 		(data)=>{console.log(data)},      //响应码等于200时的回调方法
    		(data)=>{console.log(data)}       //响应码不等于200时的回调方法
     )
    * @author FanXH
    * @param {String} url      请求地址
    * @param {obj} params      POST 的参数对象，如{age:123}
    */
    postData: (url, params) => {
        return util.requestServerData(url, 'POST', params);
    },

    postDataNew: (url, params) => {
        return util.requestServerDataNew(url, 'POST', params);
    },
    /**
    * @author FanXH
    * @param {String} url      请求地址
    * @param {obj} params      PUT 的参数对象，如{age:123}
    */
    putData: (url, params) => {
        return util.requestServerData(url, 'PUT', params);
    },
    /**
    * getData 请求服务器数据
     举例：
     util.requestServerData(

     		'http://localhost:7000/api/user/query?uername=lilei'
     ).then(
      		(data)=>{console.log(data)},      //响应码等于200时的回调方法
    		(data)=>{console.log(data)}       //响应码不等于200时的回调方法
      )
	* @author FanXH
	* @param {String} url      请求地址,把参数拼在url后面
	*/
    getData: (url) => {
        return util.requestServerData(url, 'GET', '');
    },

    getDataNew: (url) => {
        return util.requestServerDataNew(url, 'GET', '');
    },
	/*
	* @author FanXH
	* @param {String} url      请求地址,把参数拼在url后面
	*/
    delData: (url) => {
        return util.requestServerData(url, 'DELETE', '');
    },
	/**
	 * @author guomh
	 * @description 请求okapi用户平台
	 * @param {String} url      请求地址，如果是GET方式，把参数拼在url后面
	 * @param {String} method   请求方式：POST | GET | PUT
	 * @param {obj} params      POST | PUT 方式的参数对象，如{age:123}，GET方式时传空值
	 *
	*/
    requestOkapiServerData: (url, method, params) => {
        let _headers = new Headers({
            'X-Okapi-Tenant': appConfig.XOkapiTenant,
            'X-Okapi-Token': token,
            "Content-type": "application/json"
        });
        let _promise = new Promise(
            function (resolve) {
                let _myInit = {
                    method: method,
                    headers: _headers,
                    mode: 'cors'
                };
                if (method.toUpperCase() != 'GET') {
                    _myInit.body = JSON.stringify(params);
                }
                fetch(url, _myInit).then(
                    (res) => {
                        resolve(res);
                    }).catch((reason) => {
                        message.error(`请求失败，地址：${url},方法：${method},原因：${reason}`, 5);
                    });
            }
        );
        return _promise;
    },
};

export { util };



// WEBPACK FOOTER //
// src/util/util.js